module.exports = __webpack_public_path__ + "img/4a42cc07eecd46c0ebef7d28b36fcf69.b9e7f979.jpg";